import React, { useState } from 'react'
import { withRouter } from 'react-router'
import './notice-item.less'

const NoticeItem = ({ info, history }: any) => {
  const [backupImage, setBackupImage] = useState(false)

  const navDetail = (info: any) => {
    if (window.WebViewBridge?.eventLabel) {
      window.WebViewBridge?.eventLabel('NOSD01','')
    } else if (window.webkit) {
      window.webkit.messageHandlers.eventLabel.postMessage({'id': 'NOSD01'})
    }
    switch (info.jump.jump_type) {
      case 'room_fee':
        //房费充值界面
        history.push(`/payment/bed`)
        break
      case 'cold_water_fee':
        // 冷水费充值界面
        history.push(`/payment/cold-water`)
        break
      case 'repair_development':
        //保修详情
        history.push(`/repair/detail/${info?.jump?.jump_value}`)
        break
      case 'repair_evaluate':
        //保修详情
        history.push(`/repair/evaluation/${info?.jump?.jump_value}`)
        break
      case 'repair_detail':
        //保修详情
        history.push(`/repair/detail/${info?.jump?.jump_value}`)
        break
      case 'announcement':
        // 公告详情通知
        history.push(`/notice/normal-detail/list/${info.id}`)
        break
      case 'notice':
        // 普通详情通知
        history.push(`/notice/normal-detail/list/${info.id}`)
        break
      case 'audit':
        // 审核详情界面
        history.push(`/notice/audit-detail/list/${info.id}`)
        break
      case 'checkout_refund':
        // 跳转退款界面
        if (window.WebViewBridge) {
          window.WebViewBridge?.goToJump?.call(
            window.WebViewBridge,
            JSON.stringify(info.jump),
          )
        } else if (window.webkit) {
          window.webkit.messageHandlers.goToJump.postMessage(JSON.stringify(info.jump))
        }
        break
      default:
        if (window.WebViewBridge) {
          window.WebViewBridge?.goToJump?.call(
            window.WebViewBridge,
            JSON.stringify(info.jump),
          )
        } else if (window.webkit) {
          window.webkit.messageHandlers.goToJump.postMessage(JSON.stringify(info.jump))
        }
    }
  }
  return (
    <div
      onClick={() => navDetail(info)}
      className={
        info.type === 'normal' ? 'notice-item-normal' : 'notice-item-special'
      }
    >
      <div className="notice-time">
        <span>{info.time}</span>
      </div>
      <div
        className="notice-content"
        style={{ color: info.is_read ? '#898989' : '#000' }}
      >
        <p className="font-5">{info.title}</p>
        <div>
          <img
            src={backupImage ? '/public/assets/img/backup-image.png' : info.img}
            onError={() => setBackupImage(true)}
            alt="img"
          />
          <div className="notice-brief font-7">{info.brief}</div>
          <div className="notice-icon">
            {info.type === 'special' && '查看详情'}
            <i className="iconfont">&#xe611;</i>
          </div>
        </div>
      </div>
    </div>
  )
}

export default withRouter(NoticeItem)
